import React from "react";
import Competition from "./Competition";
import sidebarShadow from "../../../Common/_assets/img/placeholder/sidebar-shadow.png";

const CompetitionsAwards = ({
	competitions,
	titleName,
	show_id,
	slug,
	award_count,
}) => {
	return (
		<>
			<div
				className="font-weight-light text-uppercase text-center d-flex align-items-center justify-content-center gap-2"
				style={{
					opacity: 0.5,
					// fontSize: "1rem",
					// letterSpacing: ".2rem",
					// marginTop: "2rem",
					// marginBottom: "2rem",
					fontSize: ".75rem",
					letterSpacing: ".2rem",
					marginTop: "2rem",
					marginBottom: "2rem",
				}}
			>
				{/*<span*/}
				{/*	style={{*/}
				{/*		fontSize: "1em",*/}
				{/*		color: "#e50914",*/}
				{/*		fontWeight: "500",*/}
				{/*	}}*/}
				{/*>*/}
				{/*	{award_count}*/}
				{/*</span>*/}
				{/*<span>Emmy&reg; Nomination{award_count > 1 ? "s" : ""}</span>*/}
				<span>Nominations and Wins</span>
			</div>

			{competitions
				? competitions.map((competition, i) => {
						return (
							<React.Fragment key={i}>
								<div className="sidebar__container--nomineelist-wrapper nomination__sidebar flex-md-fill d-flex flex-column">
									<Competition
										competition={competition}
										slug={slug}
										award_count={award_count}
									/>
								</div>
							</React.Fragment>
						);
					})
				: null}

			<div className="sidebar__container--shadow d-none">
				<img src={sidebarShadow} className="" alt="Netflix" />
			</div>
		</>
	);
};

export default CompetitionsAwards;
